import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_d30865f7-cea6-4b3b-a304-86366297a19b/artifacts/0tmf5rnm_logo.jpeg";

export function Logo({ size = 28, showWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="ess-logo">
      <img
        src={LOGO_URL}
        alt="ESS-TIME"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", filter: "grayscale(100%)" }}
      />
      {showWordmark && (
        <span
          className="font-semibold tracking-tight"
          style={{ color: "var(--ess-grey)", fontSize: size * 0.6, letterSpacing: "0.02em" }}
        >
          EssTrack
        </span>
      )}
    </div>
  );
}
